import { Avatar } from 'antd';
import React from 'react';

const IntegrationIcon = ({ integration, size = 15, ...rest }) => {
  const iconPath = `/icons/integrations/${integration}.svg`;

  if (!integration) {
    return null;
  }

  return integration === 'all' ? null : (
    <Avatar shape='square' size={size} src={iconPath} {...rest} />
  );
};

export default IntegrationIcon;
